<div class="p-24" fxlayout="row" fxlayoutwrap="" id="timeline" ng-reflect-layout="row" ng-reflect-wrap="">
    <div class="timeline-content" fxLayout="column" fxFlex="100" fxFlex.gt-sm="55" fxFlex.gt-md="65">
        <div class="profile-box add-post">
            <div class="form" fxFlex>
                <textarea placeholder="Write something.."></textarea>
                <footer fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <!-- Content here, buttons icons -->
                    </div>
                    <button mat-raised-button color="accent" class="post-button" aria-label="POST">POST</button>
                </footer>
            </div>
        </div>
        <mat-divider></mat-divider>
        <div class="timeline-item" *ngFor="let post of posts">
            <header fxLayout="row" fxLayoutAlign="space-between start">
                <div class="user" fxLayout="row" fxLayoutAlign="start center">
                    <img class="avatar" [src]="post.user.avatar">
                    <div fxLayout="column">
                        <div class="title">
                            <span class="username">{{post.user.name}}</span>
                            <span>posted </span>
                        </div>
                        <div class="time">{{post.time}}</div>
                    </div>
                </div>
                <button mat-icon-button aria-label="More">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </header>
            <div class="content">
                <div *ngIf="post.message" class="message">
                    {{post.message}}
                </div>
            </div>
            <footer class="" fxLayout="column" fxLayoutAlign="start start">
                <!-- content -->
            </footer>
        </div>
    </div>
    <div class="timeline-sidebar" fxLayout="column" fxFlex="100" fxFlex.gt-sm="45" fxFlex.gt-md="35">
        <div class="profile-box latest-activity" fxLayout="column">
            <header class="mat-accent-bg" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="title">Primary Detail</div>
                <mat-icon>contact_phone</mat-icon>
            </header>
            <div class="content" fxLayout="row" fxLayoutWrap>
            </div>
        </div>

        <div class="profile-box latest-activity" fxLayout="column">
            <header class="mat-accent-bg" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="title">Primary Detail</div>
                <mat-icon>contact_phone</mat-icon>
            </header>
            <div class="content" fxLayout="row" fxLayoutWrap>
            </div>
        </div>

        <div class="profile-box latest-activity" fxLayout="column">
            <header class="mat-accent-bg" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="title">Primary Detail</div>
                <mat-icon>contact_phone</mat-icon>
            </header>
            <div class="content" fxLayout="row" fxLayoutWrap>
            </div>
        </div>
    </div>
</div>
